import Vue from "vue";


// +----------------------------------------------------------------------
// | Desc:在Vue原型上挂载加密方法
// +----------------------------------------------------------------------
Vue.prototype.$encryptUrl = function (data, key, expire) {
  // 如果 key 为空，可以在这里设置默认密钥
  if (!key) {
    key = "your_default_key_here"; // 替换为你的密钥
  }

  // 将数据进行 Base64 编码
  data = btoa(data);

  // 生成与数据长度相同的密钥字符序列
  let x = 0;
  let l = key.length;
  let char = "";
  for (let i = 0; i < data.length; i++) {
    if (x === l) x = 0;
    char += key.charAt(x);
    x++;
  }

  // 添加过期时间
  let str = expire > 0 ? ("" + (expire + Math.floor(Date.now() / 1000))).padStart(10, "0") : "0000000000";

  // 对数据进行加密
  for (let i = 0; i < data.length; i++) {
    str += String.fromCharCode(data.charCodeAt(i) + (char.charCodeAt(i) % 256));
  }

  // 将结果进行 Base64 编码，并替换特殊字符为 URL 安全字符
  return btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};


// +----------------------------------------------------------------------
// | EXCEL下载器
// +----------------------------------------------------------------------
Vue.prototype.$downLoad = function (api, parameter, fileName) {
  var config = this.$configBase();
  var that = this;
  var token = localStorage.getItem("token");
  if (this.$isblank(token)) {
    var token = sessionStorage.getItem("token");
  }
  if (this.$isblank(token)) {
    this.$msg("登录信息过期", "warning");
    return;
  }
  parameter["token"] = token;
  var url = config.api + api + "?parm=" + encodeURIComponent(JSON.stringify(parameter));
  this.$loading(true, "下载中...");
  var xhr = new XMLHttpRequest();
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    console.log(xhr);
    if (this.status == 200) {
      var blob = this.response;
      // 创建下载链接
      var a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = fileName;
      // 模拟点击下载
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(a.href);
      that.$loading(false);
      that.$msg("下载成功,请在目录查看", "success");
    }
  };
  xhr.send();
};